export default "/assets/images/white-filter.20668426dd8badfe.png";